module.exports = __webpack_public_path__ + "static/mail-81c00177ae19056112043aab728f0249.mp4";